import BlogPostPage from 'ui/pages/blog/[slug]';

import Layout from '@/components/layouts/Layout';

export { getStaticProps, getStaticPaths } from 'ui/pages/blog/[slug]'

export default function BlogPost(props) {
  return <BlogPostPage {...props} layout={Layout} />;
}

BlogPost.getLayout = (children) => children;
BlogPost.prettyName = 'Landing Blog Post';
